import { Card, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { ProjectSummary } from '@/api/projects';
import { UnstyledButtonLink } from '@/components/links';
import { StatusBadge } from '@/components/StatusBadge';
import { useFormat } from '@/components/useFormat';
import { brand } from '@/theme/theme';

/** One project in the client list: organization eyebrow, name, one status badge, acquisition date. */
export function ProjectCard({ project }: { project: ProjectSummary }) {
  const { t } = useTranslation('projects');
  const { date } = useFormat();
  return (
    <UnstyledButtonLink to="/projects/$projectId" params={{ projectId: project.public_id }} style={{ display: 'block' }}>
      <Card h="100%">
        <Stack gap="sm">
          <Group justify="space-between" align="flex-start" wrap="nowrap">
            <Text fz={12} fw={700} tt="uppercase" c={brand.textMuted} style={{ letterSpacing: '0.1em' }}>
              {project.organization.name}
            </Text>
            <StatusBadge
              status={project.client_status}
              scope="project"
              counts={project.analyses_summary}
            />
          </Group>
          <Text fz={18} fw={600} lh={1.3}>
            {project.name}
          </Text>
          <Text fz={14} c={brand.textMuted}>
            {t('project.acquisitionDate')}: {date(project.acquisition_date)}
          </Text>
        </Stack>
      </Card>
    </UnstyledButtonLink>
  );
}
